import * as testimonieDiapoStyles from "../../styles/internal-page/testimonie-diapo.module.scss";

import React from "react";
import DiapoPres from "../shared/carrousels/DiapoPres";
import TestimonieContent from "./TestimonieContent";
import { useTranslation } from "react-i18next";



const TestimonieDiapo = ({content, hasNoTitle}) => {
	let tmpContent = {...content};
	const {t} = useTranslation();


	let testimonies = []
	if (content?.testimonies && content?.testimonies.length > 0) {
		testimonies = content?.testimonies
						.filter ( (e) => !!e)
						.map((elem)=> {
							return ({
								...elem,
								children:
									<TestimonieContent elem={elem}/>
							})
						})
	}
	tmpContent.testimonies = testimonies
	if(testimonies.length === 0) {
		return <></>
	}
	return (
		<div className={testimonieDiapoStyles.main}>
			{!hasNoTitle && <h2>
				{t("exed.product.testimonies.title")}
			</h2>}
			<DiapoPres content={tmpContent}/>
		</div>
	);
};

export default TestimonieDiapo;
